module.exports = "<div class=\"tmb-page\">\r\n    <!-- start app spinner -->\r\n    <tmb-spinner></tmb-spinner>\r\n    <!-- end app spinner -->\r\n    <router-outlet></router-outlet>  \r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/layout/card-page.component.html
// module id = ../../../../../src/app/components/layout/card-page.component.html
// module chunks = main